// extracted by mini-css-extract-plugin
module.exports = {"layout":"logout_layout__ftV6f","panel":"logout_panel__2CyAZ","wrapper":"logout_wrapper__1vmL0","loggedOut":"logout_loggedOut__3hgmD","whereTo":"logout_whereTo__3npO0"};